/**
 * 日付を指定したフォーマットの文字列に変換する
 *
 * @param date 日付
 * @param format フォーマット
 * @returns 日付文字列
 */
export function formatDate(date, format) {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString();
    const day = date.getDate().toString();
    const hours = date.getHours().toString();
    const minutes = date.getMinutes().toString();
    const seconds = date.getSeconds().toString();
    format = format.replace(/Y/g, year);
    format = format.replace(/m/g, month);
    format = format.replace(/d/g, day);
    format = format.replace(/H/g, hours);
    format = format.replace(/i/g, minutes);
    format = format.replace(/s/g, seconds);
    return format;
}
